import { twMerge } from 'tailwind-merge';

import { useTheme } from '@/_shared';

import type { DivProps } from '../../types';

export const ModalFooter = ({ ref, ...props }: DivProps) => {
  const { children, className, ...other } = props;
  const { modal } = useTheme();

  const cls = twMerge(modal.footer, className);

  return (
    <footer className={cls} ref={ref} {...other}>
      {children}
    </footer>
  );
};
